import RoomHeader from './RoomHeader';

export default RoomHeader;
